'use strict';

class CTextAreaController{
  constructor(){
  }
  $onInit(){
    if (angular.isUndefined(this.placeholder)) {
      this.placeholder = this.label;
    }
  }
}
export default CTextAreaController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components-bootstrap/c-email/c-email.controller.js